<div class="release-container">
	<form [formGroup]="leaseDetailService.entityRelease" (ngSubmit)="leaseDetailService.saveRelease()">

		<!-- Card 1: Formulario de entrega -->
		<div class="info-card">
			<div class="card-header">
				<i class="fa-solid fa-truck-ramp-box text-blue-600"></i>
				<h3>Formulario de entrega</h3>
			</div>
			<div class="card-content">
				<div class="grid">
					<div class="col-12 md:col-6 xl:col-4">
						<div class="field field-flex">
							<label for="date">
								<span class="p-error">*</span>Fecha:
							</label>
							<input type="date" pInputText id="date" formControlName="date" required />
							<ng-container *ngIf="e.get('date')?.invalid && (e.get('date')?.dirty || e.get('date')?.touched)">
								<small class="p-error" *ngIf="e.get('date')?.errors?.['required']">La fecha es obligatoria.</small>
							</ng-container>
						</div>
					</div>
					<div class="col-12 md:col-6 xl:col-4">
						<app-input-single-file
							label="Formato de entrega"
							(fileUrl)="onFileSelected($event)"
							(fileDeleted)="onFileDeleted()"
							[tooltip]="'Formato oficial de entrega del activo'"
							[documentName]="'deliveryProof'"
							[folder]="'delivery'"
							[id]="leaseDetailService.id"
							[fileUrlValue]="leaseDetailService.data?.assetDelivery?.proof">
						</app-input-single-file>
					</div>
					<div class="col-12 text-right">
						<button pButton pRipple label="Guardar" icon="fa-solid fa-check" class="p-button-success" type="submit"></button>
					</div>
				</div>
			</div>
		</div>

		<!-- Card 2: Fotografías de entrega -->
		<div class="info-card">
			<div class="card-header">
				<i class="fa-solid fa-camera text-green-600"></i>
				<h3>Fotografías de entrega</h3>
				<span class="photo-count" *ngIf="photos.length > 0">
					{{ photos.length }} foto{{ photos.length !== 1 ? 's' : '' }}
				</span>
			</div>
			<div class="card-content">
				<div class="grid">
					<div class="col-12 md:col-6 xl:col-4">
						<app-input-multi-file
							label="Subir fotografías"
							(filesChanged)="onPhotosChanged($event)"
							(downloadRequested)="onDownloadPhoto($event)"
							[tooltip]="'Fotografías de la entrega del activo al cliente'"
							[documentName]="'deliveryPhotos'"
							[folder]="'delivery'"
							[id]="leaseDetailService.id"
							[fileUrlValues]="photos"
							[acceptedFormats]="'image/*'"
							[maxFiles]="20">
						</app-input-multi-file>
					</div>
					<div class="col-12">
						<app-image-gallery
							[images]="photos"
							[loading]="isLoading"
							[emptyTitle]="isDelivered ? 'Sin fotografías de entrega' : 'Activo no entregado'"
							[emptyDescription]="isDelivered
								? 'No se han subido fotografías para esta entrega.'
								: 'El activo aún no ha sido entregado al cliente.'"
							[emptyIcon]="isDelivered ? 'fa-solid fa-images' : 'fa-solid fa-truck'"
							[columns]="4">
						</app-image-gallery>
					</div>
				</div>
			</div>
		</div>

	</form>
</div>
